{
  "header": {
    "nameShowStaticText": false,
    "nameStaticText": "",
    "nameVariable": {
      "id": "d68fc7e2-4b22-41ca-8f38-8fbc9635c286",
      "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
      "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=6012",
      "displayName": "ProductInstanceUri",
      "variablePath": "Identification.ProductInstanceUri",
      "dataType": "String",
      "valueRank": -1,
      "modellingRule": "Optional",
      "hasProperties": false
    },
    "modelShowStaticText": false,
    "modelStaticText": "",
    "modelVariable": {
      "id": "fada2b00-02bd-4d99-9d1c-df286baf16d1",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6008",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification (Crane System)",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "6357b1a1-dfa8-47d0-ac23-5641a43b76b7",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=6009",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "ProductUri",
              "showAsLink": false,
              "valueVariable": {
                "id": "d68fc7e2-4b22-41ca-8f38-8fbc9635c286",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=6012",
                "displayName": "ProductInstanceUri",
                "variablePath": "Identification.ProductInstanceUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Numbers",
              "showAsLink": false,
              "valueVariable": {
                "id": "38bfd7ff-97b0-46b5-9067-b751330e7e21",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=6010",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Revision",
              "showAsLink": false,
              "valueVariable": {
                "id": "f69e19ba-8a14-4006-8202-2f799deca09a",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6011",
                "displayName": "SoftwareRevision",
                "variablePath": "Identification.SoftwareRevision",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Build Year",
              "showAsLink": false,
              "valueVariable": {
                "id": "0e39fffc-ff21-4b3a-9a4b-7c3e66d20c3a",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6004",
                "displayName": "YearOfConstruction",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "UInt16",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "showAsLink": false,
              "valueVariable": {
                "id": "bb881912-532e-4d18-8de4-8196dc04407e",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6012",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Location",
              "showAsLink": false,
              "valueVariable": {
                "id": "527a211a-271a-4439-b151-a82ba4112f97",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6029",
                "displayName": "Location",
                "variablePath": "Identification.Location",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "fada2b00-02bd-4d99-9d1c-df286baf16d1",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6008",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "5bd3b4ed-2316-480e-86c3-2d1651e38b04",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Robotics/;i=16359",
                "displayName": "ProductCode",
                "variablePath": "Identification.ProductCode",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Status Overview (Crane System)",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "OperationalMode",
              "showAsLink": false,
              "valueVariable": {
                "id": "78859a86-5ff8-4317-9403-a42025d5c1c6",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Robotics/;i=15912",
                "displayName": "OperationalMode",
                "variablePath": "ParameterSet.<ParameterIdentifier>.CraneOperationalMode",
                "dataType": "Enum",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "OTHER",
                  "1": "MANUAL",
                  "2": "SEMIAUTOMATIC",
                  "3": "FULLAUTOMATIC",
                  "4": "BYPASS_ON",
                  "5": "MAINTENANCE"
                }
              }
            }
          ]
        },
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#000000",
                  "value": "True",
                  "label": "Moving"
                },
                {
                  "backgroundColor": "#ff2600",
                  "textColor": "#000000",
                  "value": "False",
                  "label": "Stopped"
                }
              ],
              "label": "Moving",
              "valueVariable": {
                "id": "e4d4441d-11b5-43a5-a262-f68696d661b2",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=2037",
                "displayName": "IsMoving",
                "variablePath": "ParameterSet.<ParameterIdentifier>.IsMoving",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Position",
              "showAsLink": false,
              "valueVariable": {
                "id": "5b6546ad-e00f-419c-a923-47795fb376a7",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Robotics/;i=15863",
                "displayName": "ActualPosition",
                "variablePath": "ParameterSet.<ParameterIdentifier>.ActualPosition",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": false,
                "hasRange": false
              }
            }
          ],
          "title": "Axes",
          "placeholderObject": "MotionDevices.<MotionDeviceIdentifier>.[PLACEHOLDER].Axes.<AxisIdentifier>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "32f13ecd-2f0c-45c5-afb2-6a8f6c4d99e4",
            "modelUri": "http://opcfoundation.org/UA/",
            "nodeId": "ns=http://opcfoundation.org/UA/;i=61",
            "displayName": "baseName",
            "variablePath": "baseName",
            "dataType": "String",
            "valueRank": -1,
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Total Capacity",
              "showAsLink": false,
              "valueVariable": {
                "id": "2c13033b-dea8-4889-a617-a944f524feef",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=6018",
                "displayName": "CraneRatedCapacity",
                "variablePath": "ParameterSet.<ParameterIdentifier>.CraneRatedCapacity",
                "dataType": "Float",
                "valueRank": -2,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Global Speed Limit ",
              "showAsLink": false,
              "valueVariable": {
                "id": "6eabcf3e-63c4-463c-9ce1-0f6ed34ce18b",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=2381",
                "displayName": "SpeedLimitGlobalEnabled",
                "variablePath": "ParameterSet.<ParameterIdentifier>.SpeedLimitGlobalEnabled",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "External Control",
              "showAsLink": false,
              "valueVariable": {
                "id": "04e76066-3492-40a1-b525-f90108536f0c",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=2369",
                "displayName": "ExternalControlRequest",
                "variablePath": "ParameterSet.<ParameterIdentifier>.ExternalControlRequest",
                "dataType": "Enum",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false,
                "enumValues": {
                  "0": "NOT_REQUESTED",
                  "1": "REQUESTED_AND_CONTROL_ACTIVE",
                  "2": "REQUESTED_AND_CONTROL_INACTIVE",
                  "3": "REQUESTED_AND_CONTROL_BYPASSED"
                }
              }
            },
            {
              "type": 1,
              "isPlaceholder": true,
              "label": "Load",
              "condition": {
                "values": ["HOIST"],
                "valueVariable": {
                  "id": "db848683-aa5a-46b9-b5a4-31878001face",
                  "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                  "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=6004",
                  "displayName": "CraneMotionDeviceCategory",
                  "variablePath": "CraneMotionDeviceCategory",
                  "dataType": "Enum",
                  "valueRank": -1,
                  "modellingRule": "Mandatory",
                  "hasProperties": false,
                  "enumValues": {
                    "0": "HOIST",
                    "1": "TROLLEY_TRAVERSE",
                    "2": "BRIDGE_OR_GANTRY_TRAVEL",
                    "3": "LOAD_LIFTING_ATTACHMENT",
                    "4": "ROTATING_OR_SLEWING",
                    "5": "LUFFING",
                    "6": "POWER_SUPPLY_MACHINERY",
                    "7": "OTHER"
                  }
                }
              },
              "placeholderObject": "MotionDevices.<MotionDeviceIdentifier>.[PLACEHOLDER]",
              "labelVariable": {
                "id": "0cba79d3-a394-4944-9ab9-18688b82bb23",
                "modelUri": "http://opcfoundation.org/UA/",
                "nodeId": "ns=http://opcfoundation.org/UA/;i=61",
                "displayName": "baseName",
                "variablePath": "baseName",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              },
              "valueVariable": {
                "id": "4fab04e5-0bae-4a84-8438-5a372bfe9968",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Robotics/;i=6723",
                "displayName": "Mass",
                "variablePath": "ActualLoad.Mass",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": false,
                "hasRange": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Protective Functions",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Name",
              "showAsLink": false,
              "valueVariable": {
                "id": "979820cf-75b2-4bcf-820e-4c796f110878",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Robotics/;i=18810",
                "displayName": "Name",
                "variablePath": "Name",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Enabled",
              "showAsLink": false,
              "valueVariable": {
                "id": "6edced34-0f0a-49f6-b27f-62173ec903f3",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Robotics/;i=18811",
                "displayName": "Enabled",
                "variablePath": "Operational.Enabled",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Active",
              "showAsLink": false,
              "valueVariable": {
                "id": "c97e2a6d-b9f8-4cd8-a266-54fd1e7317bf",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Robotics/;i=18812",
                "displayName": "Active",
                "variablePath": "ParameterSet.Active",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ],
          "placeholderObject": "ProtectiveFunctions.[PLACEHOLDER]",
          "titleVariable": {
            "id": "67cf6b53-d37c-42cf-a6e0-a05e43572920",
            "modelUri": "http://opcfoundation.org/UA/",
            "nodeId": "ns=http://opcfoundation.org/UA/;i=61",
            "displayName": "baseName",
            "variablePath": "baseName",
            "dataType": "String",
            "valueRank": -1,
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Motion Devices",
      "rows": []
    },
    {
      "isPlaceholder": true,
      "title": "",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "72329c0f-ce70-4cf4-a810-e7388ebcadea",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=6009",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "ProductUri",
              "showAsLink": false,
              "valueVariable": {
                "id": "5af9fed5-d7d2-43dc-866f-71e316ceb617",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6015",
                "displayName": "ProductInstanceUri",
                "variablePath": "Identification.ProductInstanceUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "e5f6da44-02da-4e7c-80a5-3f7147359abe",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=6010",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Revision",
              "showAsLink": false,
              "valueVariable": {
                "id": "52e8f397-ea12-4e5b-b960-71d12031acc2",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6011",
                "displayName": "SoftwareRevision",
                "variablePath": "Identification.SoftwareRevision",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Build Year",
              "showAsLink": false,
              "valueVariable": {
                "id": "c012ad18-4b9e-4bd1-b497-e0abcdffb0ab",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6004",
                "displayName": "YearOfConstruction",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "UInt16",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "showAsLink": false,
              "valueVariable": {
                "id": "a7a7c45f-8397-47d0-8305-164056ab9369",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6012",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "e4023425-0876-493b-a497-b0e926856a26",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6008",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "003ab347-b766-410c-9ba1-eb36afcf5761",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6009",
                "displayName": "ProductCode",
                "variablePath": "Identification.ProductCode",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "MotionDeviceCategory",
              "showAsLink": false,
              "valueVariable": {
                "id": "f71e78b7-3bb4-4f5d-97a0-5439d385b9b6",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Robotics/;i=16362",
                "displayName": "MotionDeviceCategory",
                "variablePath": "MotionDeviceCategory",
                "dataType": "Enum",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "OTHER",
                  "1": "ARTICULATED_ROBOT",
                  "2": "SCARA_ROBOT",
                  "3": "CARTESIAN_ROBOT",
                  "4": "SPHERICAL_ROBOT",
                  "5": "PARALLEL_ROBOT",
                  "6": "CYLINDRICAL_ROBOT"
                }
              }
            }
          ],
          "title": "Identification (Motion Device)"
        },
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#000000",
                  "value": "True",
                  "label": "Moving"
                },
                {
                  "backgroundColor": "#ff2600",
                  "textColor": "#000000",
                  "value": "False",
                  "label": "Stopped"
                }
              ],
              "label": "isMoving",
              "valueVariable": {
                "id": "237ddf7e-d4fd-476d-a2db-b4dae3ec7318",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=2037",
                "displayName": "IsMoving",
                "variablePath": "ParameterSet.<ParameterIdentifier>.IsMoving",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Rate Speed",
              "showAsLink": false,
              "valueVariable": {
                "id": "eb7077be-6e83-47c7-bdf5-0ba2cdbaa32e",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=1852",
                "displayName": "RatedSpeed",
                "variablePath": "ParameterSet.<ParameterIdentifier>.RatedSpeed",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Position",
              "showAsLink": false,
              "valueVariable": {
                "id": "b79aede6-3366-46c4-84ec-4faef7bbf42f",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Robotics/;i=16667",
                "displayName": "EngineeringUnits",
                "variablePath": "ParameterSet.<ParameterIdentifier>.ActualPosition.EngineeringUnits",
                "dataType": "EUInformation",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Speed",
              "showAsLink": false,
              "valueVariable": {
                "id": "018a88bc-90c9-4027-8205-7fc4a18e338a",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Robotics/;i=16668",
                "displayName": "ActualSpeed",
                "variablePath": "ParameterSet.<ParameterIdentifier>.ActualSpeed",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Axis Function",
              "showAsLink": false,
              "valueVariable": {
                "id": "1010bee7-86ea-4db1-8bc5-f85727d8ff6d",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=6017",
                "displayName": "ValueAsText",
                "variablePath": "ParameterSet.<ParameterIdentifier>.CraneAxisFunction.ValueAsText",
                "dataType": "LocalizedText",
                "valueRank": -2,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Speed Limit Positive Direction",
              "showAsLink": false,
              "valueVariable": {
                "id": "7f2b35b9-24f1-457d-b4f2-47873c8be0ca",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=2031",
                "displayName": "SpeedLimitDirMinus",
                "variablePath": "ParameterSet.<ParameterIdentifier>.SpeedLimitDirMinus",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Speed Limit Negative Direction",
              "showAsLink": false,
              "valueVariable": {
                "id": "7dafc029-fb31-4264-a53a-ee0c211843ed",
                "modelUri": "http://opcfoundation.org/UA/CranesHoists/",
                "nodeId": "nsu=http://opcfoundation.org/UA/CranesHoists/;i=1950",
                "displayName": "SpeedLimitDirPlus",
                "variablePath": "ParameterSet.<ParameterIdentifier>.SpeedLimitDirPlus",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Load",
              "valueVariable": {
                "id": "4fab04e5-0bae-4a84-8438-5a372bfe9968",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "nsu=http://opcfoundation.org/UA/Robotics/;i=6723",
                "displayName": "Mass",
                "variablePath": "ActualLoad.Mass",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            }
          ],
          "placeholderObject": "Axes.<AxisIdentifier>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "0cba79d3-a394-4944-9ab9-18688b82bb23",
            "modelUri": "http://opcfoundation.org/UA/",
            "nodeId": "ns=http://opcfoundation.org/UA/;i=61",
            "displayName": "baseName",
            "variablePath": "baseName",
            "dataType": "String",
            "valueRank": -1,
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ],
      "placeholderObject": "MotionDevices.<MotionDeviceIdentifier>.[PLACEHOLDER]",
      "titleVariable": {
        "id": "5af9fed5-d7d2-43dc-866f-71e316ceb617",
        "modelUri": "http://opcfoundation.org/UA/Machinery/",
        "nodeId": "nsu=http://opcfoundation.org/UA/Machinery/;i=6015",
        "displayName": "baseName",
        "variablePath": "baseName",
        "dataType": "String",
        "valueRank": -1,
        "modellingRule": "Mandatory",
        "hasProperties": true
      }
    }
  ]
}
